/**
 * Wizard 4 household: every dog on the same step.
 * Copy and field rules come from the step markup (quiz.wizard_4) and PetFlowState.
 */
(function () {
  var MAX = 20;
  var PER_DOG = ['age', 'breed', 'food', 'eating', 'weight', 'composition', 'activity', 'allergies', 'issues', 'snacks'];

  function stateOf(handler) {
    return handler.flow.state;
  }

  function refreshButton(handler) {
    if (typeof handler.updateButtonStates === 'function') {
      handler.updateButtonStates(handler.flow.state.getCurrentStep());
    }
  }

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function accentTitle(before, accent, after) {
    return (
      '<span>' + before + ' </span>' +
      '<span class="accent accent--freshwater shape_1 nowrap">' + accent + '</span>' +
      '<span> ' + after + '</span>'
    );
  }

  function dogName(dog) {
    var raw = dog && dog.name ? dog.name : '';
    if (typeof window.normalizePetNameEdges === 'function') return window.normalizePetNameEdges(raw);
    return String(raw).trim();
  }

  function dogHasProgressBeyondName(dog) {
    if (!dog) return false;
    return !!(
      dog.gender ||
      dog.spayed === true ||
      dog.spayed === false ||
      dog.ageGroup ||
      dog.breed ||
      dog.breedUnknown ||
      dog.breedMixed ||
      (dog.weight != null && dog.weight !== '') ||
      dog.composition ||
      dog.activity ||
      dog.snacks ||
      (Array.isArray(dog.currentFood) && dog.currentFood.length) ||
      dog.eating ||
      dog.health ||
      (Array.isArray(dog.healthIssues) && dog.healthIssues.length) ||
      (Array.isArray(dog.allergies) && dog.allergies.length)
    );
  }

  function confirmRemoveDog(root, dog, onConfirm) {
    var modal = root.querySelector('[data-wizard-remove-dog-modal]');
    var text = modal && modal.querySelector('[data-wizard-remove-text]');
    var confirmBtn = modal && modal.querySelector('[data-wizard-remove-confirm]');
    var cancelBtn = modal && modal.querySelector('[data-wizard-remove-cancel]');
    if (!modal || !text || !confirmBtn || !cancelBtn) {
      onConfirm();
      return;
    }
    var template = root.getAttribute('data-remove-text') || '';
    text.textContent = template.replace(/%\{name\}/g, dogName(dog));
    modal.style.display = 'flex';

    function close() {
      modal.style.display = 'none';
      confirmBtn.removeEventListener('click', onYes);
      cancelBtn.removeEventListener('click', close);
      modal.removeEventListener('click', onBackdrop);
      document.removeEventListener('keydown', onKey);
    }
    function onYes() {
      close();
      onConfirm();
    }
    function onBackdrop(event) {
      if (event.target === modal) close();
    }
    function onKey(event) {
      if (event.key === 'Escape') close();
    }
    confirmBtn.addEventListener('click', onYes);
    cancelBtn.addEventListener('click', close);
    modal.addEventListener('click', onBackdrop);
    document.addEventListener('keydown', onKey);
    cancelBtn.focus();
  }

  function mountName(handler) {
    var root = handler.currentStepElement.querySelector('[data-wizard-name]');
    if (!root) return;
    var state = stateOf(handler);
    var dogs = state.ensureDogs();
    var title = root.querySelector('[data-wizard-name-title]');
    var list = root.querySelector('[data-wizard-name-list]');
    var add = root.querySelector('[data-wizard-add-dog]');
    var many = dogs.length > 1;

    if (title) {
      title.innerHTML = accentTitle(
        root.getAttribute(many ? 'data-title-many-before' : 'data-title-one-before'),
        root.getAttribute(many ? 'data-title-many-accent' : 'data-title-one-accent'),
        root.getAttribute(many ? 'data-title-many-after' : 'data-title-one-after')
      );
    }

    list.innerHTML = '';
    dogs.forEach(function (dog, index) {
      var field = document.createElement('div');
      field.className = 'form-field wizard-name-row';
      var input = document.createElement('input');
      input.type = 'text';
      input.name = 'dogName';
      input.required = true;
      input.autocomplete = 'off';
      input.placeholder = root.getAttribute('data-placeholder') || '';
      input.value = dog.name || '';
      input.setAttribute('data-step', 'name');
      input.setAttribute('data-field', 'name');
      input.setAttribute('data-dog-index', String(index));
      input.addEventListener('input', function () {
        state.setDogField(index, 'name', input.value);
        if (typeof state.prefillFromRemoved === 'function') state.prefillFromRemoved(index);
        refreshButton(handler);
      });
      field.appendChild(input);
      if (dogs.length > 1) {
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'wizard-remove-dog';
        remove.setAttribute('aria-label', root.getAttribute('data-remove') || 'X');
        remove.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0919/3534/2856/files/cross-neutral-800.svg?v=1782379412" alt="">';
        remove.addEventListener('click', function () {
          var current = state.ensureDogs()[index];
          var drop = function () {
            state.removeDog(index);
            mountName(handler);
          };
          if (dogHasProgressBeyondName(current)) {
            confirmRemoveDog(root, current, drop);
            return;
          }
          drop();
        });
        field.appendChild(remove);
      }
      list.appendChild(field);
    });

    if (add) {
      add.textContent = root.getAttribute('data-add') || '';
      add.hidden = dogs.length >= MAX;
      add.onclick = function () {
        if (state.ensureDogs().length >= MAX) return;
        state.addDog();
        mountName(handler);
      };
    }
    refreshButton(handler);
  }

  function radio(name, id, value, label, dogIndex, field) {
    var wrap = document.createElement('div');
    wrap.className = 'form-field';
    var input = document.createElement('input');
    input.type = 'radio';
    input.name = name;
    input.id = id;
    input.value = value;
    input.setAttribute('data-step', 'spayed');
    input.setAttribute('data-field', field);
    input.setAttribute('data-dog-index', String(dogIndex));
    var lab = document.createElement('label');
    lab.htmlFor = id;
    lab.className = 'radio-option';
    var text = document.createElement('span');
    text.className = 'radio-text';
    text.textContent = label;
    lab.appendChild(text);
    wrap.appendChild(input);
    wrap.appendChild(lab);
    return { wrap: wrap, input: input };
  }

  function mountGender(handler) {
    var root = handler.currentStepElement.querySelector('[data-wizard-gender]');
    if (!root) return;
    var state = stateOf(handler);
    var dogs = state.ensureDogs();
    var list = root.querySelector('[data-wizard-gender-list]');
    list.innerHTML = '';

    dogs.forEach(function (dog, index) {
      var block = document.createElement('section');
      block.className = 'wizard-dog-block';
      var title = document.createElement('h2');
      title.className = 'quiz-title';
      var name = dog.name || '';
      var before = String(root.getAttribute('data-title-before') || '').trim();
      var after = String(root.getAttribute('data-title-after') || '').trim();
      var shape = (index % 5) + 1;
      title.innerHTML =
        '<span>' + esc(before) + '  </span>' +
        '<span class="accent accent--freshwater shape_' + shape + ' nowrap">' + esc(name) + '</span>' +
        '<span>  ' + esc(after) + '</span>';
      block.appendChild(title);

      var genderWrap = document.createElement('div');
      genderWrap.className = 'form-wrap wizard-choice-row';
      ['female', 'male'].forEach(function (value) {
        var label = value === 'female' ? root.getAttribute('data-girl') : root.getAttribute('data-boy');
        var built = radio('gender-' + index, 'gender-' + index + '-' + value, value, label, index, 'gender');
        if (dog.gender === value) built.input.checked = true;
        built.input.addEventListener('change', function () {
          if (!built.input.checked) return;
          state.setDogField(index, 'gender', value);
          mountGender(handler);
        });
        genderWrap.appendChild(built.wrap);
      });
      block.appendChild(genderWrap);

      if (dog.gender === 'female' || dog.gender === 'male') {
        var followWrap = document.createElement('div');
        followWrap.className = 'wizard-follow-wrap';
        var follow = document.createElement('p');
        follow.className = 'wizard-body wizard-follow-title';
        follow.textContent = dog.gender === 'female'
          ? root.getAttribute('data-follow-girl')
          : root.getAttribute('data-follow-boy');
        followWrap.appendChild(follow);
        var spayedWrap = document.createElement('div');
        spayedWrap.className = 'form-wrap wizard-choice-row';
        [['true', root.getAttribute('data-yes')], ['false', root.getAttribute('data-no')]].forEach(function (pair) {
          var built = radio('spayed-' + index, 'spayed-' + index + '-' + pair[0], pair[0], pair[1], index, 'spayed');
          if (String(dog.spayed) === pair[0]) built.input.checked = true;
          built.input.addEventListener('change', function () {
            if (!built.input.checked) return;
            var wasComplete = state.validateStep('spayed');
            state.setDogField(index, 'spayed', pair[0] === 'true');
            if (!wasComplete && state.validateStep('spayed') && handler.flow) {
              setTimeout(function () {
                if (state.getCurrentStep && state.getCurrentStep() === 'spayed') handler.flow.navigateNext();
              }, 300);
              return;
            }
            refreshButton(handler);
          });
          spayedWrap.appendChild(built.wrap);
        });
        followWrap.appendChild(spayedWrap);
        block.appendChild(followWrap);
      }
      list.appendChild(block);
    });
    var tip = document.querySelector('.branding-with-speech-bubble[data-step="spayed"]');
    if (tip) {
      tip.hidden = !dogs.some(function (dog) {
        return dog.gender === 'female' || dog.gender === 'male';
      });
    }
    refreshButton(handler);
  }

  function rewriteIds(node, index) {
    var nodes = [node].concat(Array.prototype.slice.call(node.querySelectorAll('[id]')));
    nodes.forEach(function (el) {
      if (!el.id) return;
      var next = el.id + '-dog-' + index;
      var label = node.querySelector('label[for="' + el.id + '"]');
      el.id = next;
      if (label) label.htmlFor = next;
    });
    node.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
      if (input.name) input.name = input.name + '-dog-' + index;
      input.setAttribute('data-dog-index', String(index));
    });
    node.querySelectorAll('input:not([type="radio"]):not([type="checkbox"]), select, textarea').forEach(function (input) {
      input.setAttribute('data-dog-index', String(index));
    });
  }

  function dogPronoun(dog) {
    var dutch = (document.documentElement.lang || 'nl').indexOf('nl') === 0;
    if (dutch) return dog && dog.gender === 'female' ? 'haar' : 'zijn';
    return dog && dog.gender === 'female' ? 'her' : 'his';
  }

  function questionTitle(template, name, index, dog) {
    var shape = ((Number(index) || 0) % 5) + 1;
    var safe = esc(name || '');
    var accent = '<span class="accent accent--freshwater shape_' + shape + ' nowrap">' + safe + '</span>';
    var spaced = '  ' + accent + '  ';
    var pronoun = dogPronoun(dog);
    return String(template || '')
      .replace(/\s*%\{pet_name\}\s*/g, spaced)
      .replace(/\s*\[dogname\]\s*/g, spaced)
      .replace(/\[zijn\/haar\]/g, pronoun)
      .replace(/\[haar\/zijn\]/g, pronoun)
      .replace(/\[his\/her\]/g, pronoun);
  }

  function fillDogCopyText(root, dog) {
    var pronoun = dogPronoun(dog);
    var name = dog.name || '';
    root.querySelectorAll('[data-dynamic-label] .checkbox-text, [data-dynamic-text]').forEach(function (el) {
      var template = el.dataset.originalText || el.textContent;
      if (!el.dataset.originalText) el.dataset.originalText = template;
      el.textContent = String(template)
        .replace(/%\{pet_name\}/g, name)
        .replace(/\{petname\}/g, name)
        .replace(/\[dogname\]/g, name)
        .replace(/\[zijn\/haar\]/g, pronoun)
        .replace(/\[haar\/zijn\]/g, pronoun)
        .replace(/\[his\/her\]/g, pronoun);
    });
  }

  function brandingAnchor(parent) {
    var node = parent.querySelector('[data-branding-section]');
    if (!node) return null;
    while (node.parentNode && node.parentNode !== parent) node = node.parentNode;
    return node.parentNode === parent ? node : null;
  }

  function mountCopies(handler, step) {
    if (PER_DOG.indexOf(step) === -1) return;
    var source = handler.currentStepElement.querySelector('[data-wizard-dog-fields]');
    if (!source) return;
    var state = stateOf(handler);
    var dogs = state.ensureDogs();
    var parent = source.parentNode;
    var title = parent.querySelector('.quiz-title');
    var template = title ? (title.dataset.originalText || title.textContent) : '';
    parent.querySelectorAll('[data-wizard-dog-copy], .wizard-dog-heading').forEach(function (node) {
      node.remove();
    });
    if (source.getAttribute('data-wizard-indexed') !== 'true') {
      source.setAttribute('data-dog-index', '0');
      rewriteIds(source, 0);
      source.setAttribute('data-wizard-indexed', 'true');
    }
    if (title && dogs[0]) title.innerHTML = questionTitle(template, dogs[0].name, 0, dogs[0]);
    var branding = brandingAnchor(parent);
    var stack = document.createElement('div');
    stack.className = 'wizard-dog-stack';
    parent.insertBefore(stack, title || source);
    var first = document.createElement('section');
    first.className = 'wizard-dog-section';
    stack.appendChild(first);
    if (title) first.appendChild(title);
    first.appendChild(source);
    dogs.forEach(function (dog, index) {
      if (index === 0) return;
      var heading = title ? title.cloneNode(false) : document.createElement('h2');
      heading.className = 'quiz-title';
      heading.innerHTML = questionTitle(template, dog.name, index, dog);
      var copy = source.cloneNode(true);
      copy.setAttribute('data-wizard-dog-copy', 'true');
      rewriteIds(copy, index);
      copy.querySelectorAll('input').forEach(function (input) {
        input.checked = false;
        if (input.type === 'text' || input.type === 'number') input.value = '';
      });
      fillDogCopyText(copy, dog);
      var section = document.createElement('section');
      section.className = 'wizard-dog-section';
      section.appendChild(heading);
      section.appendChild(copy);
      stack.appendChild(section);
    });
    if (branding) parent.appendChild(branding);
  }

  function largeDogOfferActive(state) {
    return !!(state && state.largeDogOffer === 'accept' && state.combinedWeightKg() >= 30);
  }

  function releaseLargeDogOfferIfLight(handler) {
    var state = stateOf(handler);
    if (!state || state.largeDogOffer !== 'accept') return false;
    if (state.combinedWeightKg() >= 30) return false;
    state.largeDogOffer = null;
    saveOffer(handler);
    return true;
  }

  window.WizardHousehold = {
    mountName: mountName,
    mountGender: mountGender,
    mountCopies: mountCopies,
    maybeLargeDogOffer: maybeLargeDogOffer,
    largeDogOfferActive: largeDogOfferActive,
    releaseLargeDogOfferIfLight: releaseLargeDogOfferIfLight
  };

  function unescapeOffer(value) {
    if (window.__wizardUnescapeHtml) return window.__wizardUnescapeHtml(value);
    return String(value || '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;|&apos;/g, "'");
  }

  function escPopup(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function popupText(key, vars) {
    var node = window.__wizardPlanCopy;
    String(key || '').split('.').forEach(function (part) {
      node = node && node[part];
    });
    var value = typeof node === 'string' ? node : '';
    if (vars) {
      Object.keys(vars).forEach(function (name) {
        value = value.replace(new RegExp('%\\{' + name + '\\}', 'g'), vars[name]);
      });
    }
    return value;
  }

  function saveOffer(handler) {
    var storage = handler.flow && handler.flow.storage;
    if (storage && storage.saveToLocalStorage && handler.flow.state && handler.flow.state.getState) {
      storage.saveToLocalStorage(handler.flow.state.getState());
    }
  }

  function pad2(value) {
    return (value < 10 ? '0' : '') + value;
  }

  function timerLabel(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var hours = Math.floor(total / 3600);
    var mins = Math.floor((total % 3600) / 60);
    var secs = total % 60;
    return pad2(hours) + 'u : ' + pad2(mins) + 'm : ' + pad2(secs) + 's';
  }

  function accentedOfferTitle(text) {
    var parts = String(text || '').split('35%');
    if (parts.length < 2) return escPopup(text);
    var rest = parts.slice(1).join('35%').replace(/^\s+/, '');
    return escPopup(parts[0]) + '  <span class="accent accent--freshwater shape_1 nowrap">35%</span>  ' + escPopup(rest);
  }

  function showOfferToast(type, html, onLink) {
    if (!window.bzToast || !window.bzToast.show) return;
    window.bzToast.show({
      type: type,
      html: html,
      onMount: onLink ? function (toast) {
        var link = toast.querySelector('[data-large-dog-reopen]');
        if (link) link.addEventListener('click', onLink);
      } : null
    });
  }

  function maybeLargeDogOffer(handler, force) {
    var state = stateOf(handler);
    releaseLargeDogOfferIfLight(handler);
    if (state.largeDogOffer === 'accept' || state.largeDogOffer === 'expired') return;
    if (!force && state.largeDogOffer === 'decline') return;
    if (state.combinedWeightKg() < 30) return;
    if (document.querySelector('[data-wizard-large-dog]')) return;
    var now = Date.now();
    if (!state.largeDogOfferDeadline) {
      state.largeDogOfferDeadline = now + 24 * 60 * 60 * 1000;
      saveOffer(handler);
    }
    if (now >= state.largeDogOfferDeadline) {
      state.largeDogOffer = 'expired';
      saveOffer(handler);
      return;
    }
    var dogs = state.ensureDogs();
    var several = dogs.length > 1;
    var title = several
      ? popupText('popup.title_several')
      : popupText('popup.title_one', { name: (dogs[0] && dogs[0].name) || '' });

    var modal = document.createElement('div');
    modal.className = 'wizard-flavor-modal wizard-large-dog';
    modal.setAttribute('data-wizard-large-dog', '');
    modal.style.display = 'flex';
    modal.innerHTML =
      '<div class="wizard-large-dog__card" role="dialog" aria-modal="true" aria-labelledby="wizard-large-dog-title">' +
        '<div class="wizard-large-dog__media">' +
          '<img alt="" src="https://cdn.shopify.com/s/files/1/0919/3534/2856/files/bernese_eating.webp?v=1790687987">' +
          '<button type="button" class="wizard-large-dog__close" data-large-dog-close aria-label="' + escPopup(popupText('popup.close')) + '">' +
            '<img alt="" src="https://cdn.instant.so/sites/l5S6VVDj4Xn0uKdA/assets/9g5yKQzWqyVBomT5/cross-2.svg" width="20" height="20">' +
          '</button>' +
        '</div>' +
        '<div class="wizard-large-dog__body">' +
          '<div class="wizard-large-dog__timer">' +
            '<span class="wizard-large-dog__timer-label">' + escPopup(popupText('popup.timer')) + '</span>' +
            '<span class="wizard-large-dog__timer-value" data-large-dog-timer></span>' +
          '</div>' +
          '<h2 id="wizard-large-dog-title" class="wizard-large-dog__title">' + accentedOfferTitle(title) + '</h2>' +
          '<p class="wizard-large-dog__copy">' + escPopup(popupText('popup.body')) + '</p>' +
          '<button type="button" class="wizard-primary-button" data-large-dog-accept>' + escPopup(popupText('popup.accept')) + '</button>' +
          '<p class="wizard-large-dog__note" data-large-dog-note></p>' +
        '</div>' +
      '</div>';

    var timerId = null;
    function close(choice) {
      if (timerId) window.clearInterval(timerId);
      timerId = null;
      state.largeDogOffer = choice;
      var firstWarning = choice === 'decline' && !state.largeDogOfferWarned;
      if (firstWarning) state.largeDogOfferWarned = true;
      saveOffer(handler);
      modal.remove();
      if (choice === 'accept') {
        showOfferToast('success', '<p>' + escPopup(popupText('popup.toast_applied')) + '</p>');
      } else if (firstWarning) {
        showOfferToast(
          'warning',
          '<p>' + escPopup(popupText('popup.toast_missed')) + ' <button type="button" class="bz-toast__link" data-large-dog-reopen>' + escPopup(popupText('popup.toast_link')) + '</button> ' + escPopup(popupText('popup.toast_after')) + '</p>',
          function () { maybeLargeDogOffer(handler, true); }
        );
      }
      if (choice !== 'accept') return;
      var bar = document.querySelector('[data-wizard-offer-text]');
      if (bar) bar.innerHTML = unescapeOffer(popupText('offer.large'));
      if (window.WizardPlan && state.getCurrentStep && state.getCurrentStep() === 'plan_overview') {
        window.WizardPlan.mount(handler, 'plan_overview');
      }
    }
    function paintTimer() {
      var left = state.largeDogOfferDeadline - Date.now();
      if (left <= 0) {
        close('expired');
        return;
      }
      var node = modal.querySelector('[data-large-dog-timer]');
      if (node) node.textContent = timerLabel(left);
    }
    var note = modal.querySelector('[data-large-dog-note]');
    if (note) note.textContent = popupText('popup.note', { button: '"' + popupText('popup.accept') + '"' });
    modal.querySelector('[data-large-dog-accept]').addEventListener('click', function () { close('accept'); });
    modal.querySelector('[data-large-dog-close]').addEventListener('click', function () { close('decline'); });
    document.body.appendChild(modal);
    paintTimer();
    timerId = window.setInterval(paintTimer, 1000);
  }
})();
